import { useEffect, useState } from "react";
import { fetchBillingConfig } from "Services/CommonServices";
import { BillingConfig } from "types/perSeat";

/**
 * App-level billing flags, the first of the two per-seat gates.
 *
 * Defaults to everything off: if the call fails we must not promise seat
 * pricing the backend won't apply. The plan's own `metadata.perSeatBilling` is
 * the second gate — both have to be true before any seat UI appears.
 */
export const useBillingConfig = (): BillingConfig & { isLoading: boolean } => {
  const [config, setConfig] = useState<BillingConfig>({
    perSeatBillingEnabled: false,
    offerEnabled: false,
  });
  const [isLoading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const response = await fetchBillingConfig();
        if (!cancelled) setConfig(response);
      } catch {
        if (!cancelled) {
          setConfig({ perSeatBillingEnabled: false, offerEnabled: false });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { ...config, isLoading };
};

export default useBillingConfig;
